import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { emptyEvent, IEvent } from '../../../../Models/Event/IEvent';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { EventDetailView } from './EventDetailView';
import * as Services from '../../../../Services/Services';
import { IEventApi } from '../../../../Services/API/Event/IEventApi';
import { MessageBarType } from '@fluentui/react';
import { isNumeric } from '../../../../Tools/Validation';

interface IEventDetailProps {

}

export const EventDetail: React.FunctionComponent<IEventDetailProps> = (props) => {

    const [event, setEvent] = React.useState<IEvent>()
    const [params, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()

    const loadEvent = async (id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventTypeApi.getEvent(id);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setEvent(result.data);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }



    React.useEffect(() => {
 
        var eventId = params.get("id");
        if (isNumeric(eventId)) {
            loadEvent(eventId)
        }
    }, []);

    return (
        <>
            {event ? <EventDetailView event={event} smallScreen={false} /> : null}
            </>
            )
}